import { Container, Row, Col, Button,Form } from 'react-bootstrap';
import '../../../App.css';
import '../../../css/bootstrap.scss';

function Dashboard() {

    return (
        <>
           
            <Container className=' mt-5'>
                <Row className=' mt-5'>

                    <Col md={12}  className=' mt-5 text-center'>
                       
                        <h3 className='text-center mt-4 text-success fst-italic'>Hello Dashboard</h3>
                       
                    </Col>
                </Row>

            </Container>

        </>
    );
}

export default Dashboard;